import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

interface RadioProps {
  selected: boolean;
  disabled?: boolean;
  size?: number;
  style?: ViewStyle;
  color?: string;
  disabledColor?: string;
}

export const Radio: React.FC<RadioProps> = ({
  selected,
  disabled = false,
  size = 18,
  style,
  color = '#EF4444',
  disabledColor = RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
}) => {
  const outerStyle: ViewStyle = {
    width: size,
    height: size,
    borderRadius: size / 2,
    borderWidth: 2,
    borderColor: disabled ? disabledColor : RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    alignItems: 'center',
    justifyContent: 'center',
  };

  const innerSize = Math.max(0, size - 8);

  return (
    <View style={[styles.outer, outerStyle, style]}> 
      {selected && <View style={[styles.inner, { width: innerSize, height: innerSize, borderRadius: innerSize / 2, backgroundColor: color }]} />}
    </View>
  );
};

const styles = StyleSheet.create({
  outer: {
    marginRight: 10,
  },
  inner: {},
});

export default Radio;


